import React from "react";
import DataGrid from './data-grid';
import { Tooltip } from '@progress/kendo-react-tooltip';
import format from "../functions/format";
import Trend from "./trend";
export default class ActivityProductLocationGrid extends React.Component {
  render() {
    var data = this.props.data;
    var column = this.props.column;
    var comparison = this.props.comparison;
    var columns = [{
      field: 'imageLink',
      title: 'Url',
      sortable: false,
      cell: props => {
        var row = props.dataItem;
        var imageLink = row.imageLink;
        var split = imageLink.split('?');
        var imageSrc = split[0] + '?width=50';
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "grid-ellipsis"
        }, /*#__PURE__*/React.createElement("a", {
          href: row.link,
          target: "_blank",
          title: row.link
        }, /*#__PURE__*/React.createElement("img", {
          src: imageSrc,
          onError: ({
            currentTarget
          }) => {
            currentTarget.onerror = null;
            currentTarget.src = 'https://s3.amazonaws.com/app.plunk.io/images/image-404.png';
          }
        }))));
      }
    }, {
      field: 'title',
      title: 'Title',
      sortable: false,
      cell: props => {
        var row = props.dataItem;
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Tooltip, {
          anchorElement: "target",
          position: "top"
        }, /*#__PURE__*/React.createElement("span", {
          title: format(row.title, '-', 0, '')
        }, format(row.title, '-', 0, ''))));
      }
    }, {
      field: 'productId',
      title: 'Sku',
      sortable: false,
      cell: props => {
        var row = props.dataItem;
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "grid-ellipsis",
          title: format(row.productId, '-', 0, '')
        }, format(row.productId, '-', 0, '')));
      }
    }, {
      field: 'city',
      title: 'City',
      cell: props => {
        var row = props.dataItem;
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "grid-ellipsis",
          title: format(row.city, '-', 0, '')
        }, row.city));
      }
    }, {
      field: 'postalCode',
      title: 'Postal Code',
      cell: props => {
        var row = props.dataItem;
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "grid-ellipsis",
          title: format(row.postalCode, '-', 0, '')
        }, row.postalCode));
      }
    }, {
      field: 'regionCode',
      title: 'Region',
      cell: props => {
        var row = props.dataItem;
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "grid-ellipsis"
        }, row.regionCode));
      }
    }, {
      field: 'views',
      title: 'Views',
      cell: props => {
        var row = props.dataItem;
        var compare = comparison.find(x => x[column] === row[column]);
        if (!compare) compare = {};
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "flex-box"
        }, /*#__PURE__*/React.createElement("span", null, format(row.views, '-', 0, '')), /*#__PURE__*/React.createElement(Trend, {
          compare: compare.views,
          data: row.views
        })));
      }
    }, {
      field: 'uniqueUsers',
      title: 'Unique Users',
      cell: props => {
        var row = props.dataItem;
        var compare = comparison.find(x => x[column] === row[column]);
        if (!compare) compare = {};
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "flex-box"
        }, /*#__PURE__*/React.createElement("span", null, format(row.uniqueUsers, '-', 0, '')), /*#__PURE__*/React.createElement(Trend, {
          compare: compare.uniqueUsers,
          data: row.uniqueUsers
        })));
      }
    }, {
      field: 'sessions',
      title: 'Sessions',
      cell: props => {
        var row = props.dataItem;
        var compare = comparison.find(x => x[column] === row[column]);
        if (!compare) compare = {};
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "flex-box"
        }, /*#__PURE__*/React.createElement("span", null, format(row.sessions, '-', 0, '')), /*#__PURE__*/React.createElement(Trend, {
          compare: compare.sessions,
          data: row.sessions
        })));
      }
    }, {
      field: 'avgTimeSpan',
      title: 'Avg Time Span',
      sortable: false,
      cell: props => {
        var row = props.dataItem;
        var avgTimeSpan = row.avgTimeSpan;
        if (typeof avgTimeSpan === 'object') {
          avgTimeSpan = JSON.stringify(avgTimeSpan);
        }
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "grid-ellipsis"
        }, format(avgTimeSpan, '-', 2, '')));
      }
    }];
    return /*#__PURE__*/React.createElement(DataGrid, {
      data: data,
      columns: columns,
      pageSize: 10,
      pagination: this.props.pagination,
      onPageRequest: this.props.onPageRequest
    });
  }
}